import { Plus } from 'lucide-react';
import { Input } from 'components/ui/input';
import { cn } from 'lib/utils';
import { ProxyAddonProps } from '../../types/pricing.types';

const MAX_PROXY_TRAFFIC_GB = 10000;

export const ProxyAddon = ({
  inputId,
  period,
  addonPricePerGb,
  proxyTrafficGb,
  onProxyTrafficChange,
}: ProxyAddonProps) => {
  const hasTraffic = proxyTrafficGb > 0;

  const handleInputChange = (value: string) => {
    const numValue = parseInt(value, 10);
    if (value === '' || (!isNaN(numValue) && numValue >= 0 && numValue <= MAX_PROXY_TRAFFIC_GB)) {
      onProxyTrafficChange(value === '' ? 0 : numValue);
    }
  };

  return (
    <div>
      <div className='mb-[22px] mt-6 h-px bg-ob-border' />
      <p className='mb-4 flex items-center gap-2.5 font-medium text-ob-text-secondary'>
        <Plus className='h-4 w-4 text-ob-focus' strokeWidth={1.5} aria-hidden />
        Proxy add-ons
      </p>
      <div className='grid grid-cols-[1fr_86px_28px] items-center gap-2.5'>
        <label htmlFor={inputId} className='text-ob-text-secondary'>
          Proxy traffic
        </label>
        <Input
          id={inputId}
          type='number'
          placeholder='0'
          value={proxyTrafficGb || ''}
          onChange={(e) => handleInputChange(e.target.value)}
          className='h-[42px] w-[86px] rounded-[9px] border-ob-border bg-ob-canvas px-3 text-base text-ob-text-secondary shadow-none placeholder:text-ob-text-secondary focus-visible:border-ob-primary focus-visible:ring-0 md:text-base'
          min='0'
          max={MAX_PROXY_TRAFFIC_GB}
        />
        <span className='text-ob-text-subtle'>GB</span>
      </div>
      <p
        className={cn('mt-3 min-h-5 text-sm text-ob-text-muted', !hasTraffic && 'invisible')}
        aria-hidden={!hasTraffic}
      >
        Addon total: ${(proxyTrafficGb * addonPricePerGb).toFixed(0)}{period === 'year' ? ' billed annually' : ''}
      </p>
    </div>
  );
};
